/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import '../text_wrapper.scss';
import SortButton from '../../Buttons/SortButton';

const Glossary = ({
  glossaryList,
  currentDocument,
  spStructure,
  handleGlossarySelected,
}) => {
  //#region DATA SETUP
  // because we now have 4 levels of relationships, we need to check what to display on all levels

  const [allRelationships, setAllRelationships] = useState([]);

  const [documentRels, setDocumentRels] = useState([]);
  const [levelOneRels, setLevelOneRels] = useState([]);
  const [levelTwoRels, setLevelTwoRels] = useState([]);
  const [levelThreeRels, setLevelThreeRels] = useState([]);
  const [levelFourRels, setLevelFourRels] = useState([]);

  const [globalRelationships, setGlobalRelationships] = useState([]);
  const [displayRelationships, setDisplayRelationships] = useState([]);

  useEffect(() => {
    const allRelationships = [];
    if (glossaryList) {
      glossaryList.forEach((item) =>
        item.Relationships.forEach((relationship) => allRelationships.push(relationship))
      );
    }

    setAllRelationships(allRelationships);
  }, [glossaryList]);

  useEffect(() => {
    setGlobalRelationships(allRelationships.filter((rel) => rel.TargetType === 'Global'));
    setDocumentRels(allRelationships.filter((rel) => rel.TargetType === 'Document'));
    setLevelOneRels(allRelationships.filter((rel) => rel.TargetType === 'LevelOne'));
    setLevelTwoRels(allRelationships.filter((rel) => rel.TargetType === 'LevelTwo'));
    setLevelThreeRels(allRelationships.filter((rel) => rel.TargetType === 'LevelThree'));
    setLevelFourRels(allRelationships.filter((rel) => rel.TargetType === 'LevelFour'));
  }, [allRelationships]);

  useEffect(() => {
    if (
      currentDocument.levelOne &&
      currentDocument.levelTwo &&
      spStructure
    ) {
      // logic to map the content to be displayed based on the relationships
      const display = [];

      // need to execute the checks in reverse order to add the highest hierarchy to the array first

      // document level
      documentRels.forEach((rel) => {
        if (rel.TargetValue === currentDocument.id) {
          const glossary = glossaryList.filter((glossary) => glossary.ID === rel.GlossaryId)[0];
          if (display.filter((glo) => glo.ID === glossary.ID).length === 0)
            display.push({ ...glossary, displayLevel: rel.TargetType });
        }
      });

      if (currentDocument.levelFour) {
        // level four (optional)
        levelFourRels.forEach((rel) => {
          if (rel.TargetValue === currentDocument.levelFour.ID) {
            const glossary = glossaryList.filter((glossary) => glossary.ID === rel.GlossaryId)[0];
            if (display.filter((glo) => glo.ID === glossary.ID).length === 0)
              display.push({ ...glossary, displayLevel: spStructure.LevelFour });
          }
        });
      }

      if (currentDocument.levelThree) {
        // level three (optional)
        levelThreeRels.forEach((rel) => {
          if (rel.TargetValue === currentDocument.levelThree.ID) {
            const glossary = glossaryList.filter((glossary) => glossary.ID === rel.GlossaryId)[0];
            if (display.filter((glo) => glo.ID === glossary.ID).length === 0)
              display.push({ ...glossary, displayLevel: spStructure.LevelThree });
          }
        });
      }

      // level two (document category)
      levelTwoRels.forEach((rel) => {
        if (rel.TargetValue === currentDocument.levelTwo.ID) {
          const glossary = glossaryList.filter((glossary) => glossary.ID === rel.GlossaryId)[0];
          if (display.filter((glo) => glo.ID === glossary.ID).length === 0)
            display.push({ ...glossary, displayLevel: spStructure.LevelTwo });
        }
      });

      // level One (business unit)
      levelOneRels.forEach((rel) => {
        if (rel.TargetValue === currentDocument.levelOne.ID) {
          const glossary = glossaryList.filter((glossary) => glossary.ID === rel.GlossaryId)[0];
          if (display.filter((glo) => glo.ID === glossary.ID).length === 0)
            display.push({ ...glossary, displayLevel: spStructure.LevelOne });
        }
      });

      // visible globally
      globalRelationships.forEach((rel) => {
        const glossary = glossaryList.filter((glossary) => glossary.ID === rel.GlossaryId)[0];
        if (display.filter((glo) => glo.ID === glossary.ID).length === 0)
          display.push({ ...glossary, displayLevel: 'Visible globally' });
      });

      setDisplayRelationships(display);
      setSortedArr(display);
    }
  }, [
    globalRelationships,
    documentRels,
    levelOneRels,
    levelTwoRels,
    levelThreeRels,
    levelFourRels,
    currentDocument,
    spStructure,
  ]);

  // console.log('globalRelationships', globalRelationships);
  // console.log('documentRels', documentRels);
  // console.log('levelOneRels', levelOneRels);
  // console.log('levelTwoRels', levelTwoRels);
  // console.log('levelThreeRels', levelThreeRels);
  // console.log('levelFourRels', levelFourRels);

  //#endregion

  //#region UI SETUP

  const [isAscending, setIsAscending] = useState(true);
  const [sortedArr, setSortedArr] = useState([]);

  // reusable function to not crowd the return unnecessarily
  const displayList = (list) =>
    list.map((glossary, index) => (
      <button
        key={index}
        className="wf-card__item__wrapper tabIndex-btn"
        onClick={() => handleGlossarySelected(glossary.ID)}
        type="button"
        tabIndex={0}
      >
        <p
          title={`${glossary.GlossaryName} | ${glossary.displayLevel && glossary.displayLevel.match('globally')
            ? glossary.displayLevel
            : 'related to the current ' + glossary.displayLevel
            }`}
        >
          {glossary.GlossaryName}
        </p>
      </button>
    ));

  //#endregion

  // no related links
  if (!displayRelationships || displayRelationships.length < 1) {
    return <p className="m-0">No related Glossaries found</p>;
  } else if (displayRelationships && displayRelationships.length < 2) {
    return <React.Fragment>{displayList(displayRelationships)}</React.Fragment>;
  } else {
    const handleOrder = () => {
      setIsAscending((currentState) => !currentState);

      setSortedArr(
        isAscending === true
          ? displayRelationships.sort((a, b) => (a.GlossaryName > b.GlossaryName ? 1 : -1))
          : displayRelationships.sort((a, b) => (a.GlossaryName < b.GlossaryName ? 1 : -1))
      );
    };

    return (
      <div className="sortable-wrapper">
        <div className="sortable-wrapper__list">{displayList(sortedArr)}</div>
        <div className="sortable-wrapper__button">
          <SortButton handleOrder={handleOrder} sort={isAscending === true ? '>' : '<'} small />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state) => ({
  glossaryList: state.client.glossaryList,
  spStructure: state.client.spStructure,
  currentDocument: state.document.currentDocument,
});

const connector = connect(mapStateToProps, null);

export default connector(Glossary);
